import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {environment} from "../../../../environments/environment";
import routesConst from "../../../constants/routes.const";
import {ClientInfoService} from "../../../services/client-info.service";
import {ActionsService} from "../../../api/actions.service";
import {StorageService} from "../../../services/storage.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-mobile-menu',
  templateUrl: './mobile-menu.component.html',
  styleUrls: ['./mobile-menu.component.sass']
})
export class MobileMenuComponent implements OnInit{
  @Input() isOpen: boolean
  @Output() closeMenu = new EventEmitter<void>();
  public brand: string;

  constructor(
    private _clientInfoService: ClientInfoService,
    private _actionService: ActionsService,
    private _storageService: StorageService,
    private _router: Router,
  ) {
  }

  ngOnInit(): void {
    this.brand = environment.brand;
  }

  public logout(): void {
    this._clientInfoService.clearLoans();
    this._actionService.logout().then((res) => {
      this._storageService.clearAll();
      this._clientInfoService.clearClient();
      this._router.navigate([routesConst.LOGIN_PAGE], {
        queryParamsHandling: 'merge',
      });
    });
    this.closeMenu.emit();
  }
}
